import React from "react";
import DynamicLinesDialog from "../../../../components/DynamicLinesDialog";
import { HRService } from "../../../../config";

const base_url = HRService.uri;

const ManageStatutoryRatesDialog = ({ open, onClose, statutoryData }) => {
  // Form fields configuration
  const formFields = [
    {
      name: "lowerBound",
      label: "Lower Bound",
      type: "number",
    },
    {
      name: "upperBound",
      label: "Upper Bound",
      type: "number",
      required: false,
    },
    {
      name: "rate",
      label: "Rate (%)",
      type: "number",
      required: false,
    },
    {
      name: "taxableAmount",
      label: "Taxable Amount",
      type: "number",
      required: false,
    },
    {
      name: "reliefAmount",
      label: "Relief Amount",
      type: "number",
      required: false,
    },
    {
      name: "effectiveFrom",
      label: "Effective From",
      type: "date",
    },
    {
      name: "effectiveTo",
      label: "Effective To",
      type: "date",
      required: false,
    },
  ];

  // Table columns configuration
  const columns = [
    { field: "lowerBound", headerName: "Lower Bound", flex: 1 },
    { field: "upperBound", headerName: "Upper Bound", flex: 1 },
    { field: "rate", headerName: "Rate (%)", flex: 1 },
    { field: "taxableAmount", headerName: "Taxable Amount", flex: 1 },
    { field: "reliefAmount", headerName: "Relief Amount", flex: 1 },
    { field: "effectiveFrom", headerName: "Effective From", flex: 1 },
    { field: "effectiveTo", headerName: "Effective To", flex: 1 },
  ];

  // Query configuration
  const queryConfig = {
    name: "statutoryRateByStatutoryId",
    modelName: "statutoryRates",
    inputField: "statutoryComponentId",
    fields: [
      "id",
      "statutoryComponentId",
      "lowerBound",
      "upperBound",
      "rate",
      "taxableAmount",
      "reliefAmount",
      "effectiveFrom",
      "effectiveTo",
    ],
  };

  // Mutation configuration
  const mutationConfig = {
    create: "createStatutoryRate",
    update: "updateStatutoryRate",
    modelName: "statutoryRate",
  };

  return (
    <DynamicLinesDialog
      open={open}
      onClose={onClose}
      title="Manage Statutory Rate Lines"
      parentData={statutoryData}
      parentIdField="statutoryComponentId"
      baseUrl={base_url}
      queryConfig={queryConfig}
      mutationConfig={mutationConfig}
      formFields={formFields}
      columns={columns}
      skipAuditFields={true}
    />
  );
};

export default ManageStatutoryRatesDialog;
